import axios from '@/utils/axiosHelper';

// 初始化
export const onGetInitDataAPI = (params) => {
  return axios({ url: '/lost/reserve/init', method: 'GET', params }, { interceptResultCode: false });
};

// 获取全服葫芦
export const hotNum = (params) => {
  return axios({
    url: '/lost/reserve/number',
    method: 'GET',
    params: {}
  }, { interceptResultCode: false });
};
// 加入组队
export const invite = (params) => {
  return axios({ url: '/lost/reserve/invite', method: 'GET', params }, { interceptResultCode: false });
};
// 领取奖励
export const reward = (params) => {
  return axios({ url: '/lost/reserve/reward', method: 'POST', params }, { interceptResultCode: false });
};
// 完成任务
export const task = (params) => {
  return axios({ url: '/lost/reserve/make', method: 'POST', params }, { interceptResultCode: false });
};







// WEBPACK FOOTER //
// ./src/pages/mitu/order/api.js